/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A User with roles information
 * @export
 * @interface InternalApiUserBasicDetailsWithRoles
 */
export interface InternalApiUserBasicDetailsWithRoles {
    /**
     * 
     * @type {number}
     * @memberof InternalApiUserBasicDetailsWithRoles
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiUserBasicDetailsWithRoles
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiUserBasicDetailsWithRoles
     */
    name: string;
    /**
     * List of role names assigned to the user
     * @type {Array<string>}
     * @memberof InternalApiUserBasicDetailsWithRoles
     */
    roles?: Array<string>;
}

/**
 * Check if a given object implements the InternalApiUserBasicDetailsWithRoles interface.
 */
export function instanceOfInternalApiUserBasicDetailsWithRoles(value: object): value is InternalApiUserBasicDetailsWithRoles {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function InternalApiUserBasicDetailsWithRolesFromJSON(json: any): InternalApiUserBasicDetailsWithRoles {
    return InternalApiUserBasicDetailsWithRolesFromJSONTyped(json, false);
}

export function InternalApiUserBasicDetailsWithRolesFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiUserBasicDetailsWithRoles {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'name': json['name'],
        'roles': json['roles'] == null ? undefined : json['roles'],
    };
}

export function InternalApiUserBasicDetailsWithRolesToJSON(json: any): InternalApiUserBasicDetailsWithRoles {
    return InternalApiUserBasicDetailsWithRolesToJSONTyped(json, false);
}

export function InternalApiUserBasicDetailsWithRolesToJSONTyped(value?: InternalApiUserBasicDetailsWithRoles | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'name': value['name'],
        'roles': value['roles'],
    };
}

